import './styles.scss';
import React, {useRef, useState} from 'react';
import {Input, Tag, Tooltip} from "antd";
import {PlusOutlined} from "@ant-design/icons";

interface Props {
    onChange?: (value: string[]) => void,
    value?: string[],
}

function Keywords({onChange, value = []}: Props) {
    // const [value, setTags] = useState([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const input = useRef(null);

    function handleClose(removedTag) {
        const curTags = value.filter(tag => tag !== removedTag);
        onChange(curTags);
    }

    function showInput() {
        setInputVisible(true);
    }

    const handleInputChange = e => {
        setInputValue(e.target.value);
    };

    function handleInputConfirm() {
        let curTags;
        if (inputValue && value && value.indexOf(inputValue) === -1) {
            curTags = [...value, inputValue];
            onChange(curTags);
        }

        setInputVisible(false);
        setInputValue('');
    }

    function onKeyDown(e) {
        if (e.key === "Escape") {
            setInputVisible(false);
            setInputValue('');
        }
    }

    return (
        <>
            {value && value.map((tag) => {
                const isLongTag = tag.length > 20;

                const tagElem = (
                    <Tag className="edit-tag" key={tag} closable onClose={() => handleClose(tag)}>
                      <span>
                        {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                      </span>
                    </Tag>
                );
                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                );
            })}
            {inputVisible && (
                <Input
                    ref={input}
                    type="text"
                    size="large"
                    className="tag-input"
                    value={inputValue}
                    autoFocus
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                    onKeyDown={onKeyDown}
                    style={{marginTop: 0}}
                />
            )}
            {!inputVisible && (
                <Tag className="site-tag-plus" onClick={showInput}>
                    <PlusOutlined/> Add Keyword
                </Tag>
            )}
        </>
    )

}

export default Keywords;